/**
 * Words that should stay lowercase in utility display names (except at start of string).
 */
const SMALL_WORDS = new Set(['of', 'and', 'the', 'or', 'for', 'in', 'to', 'a', 'an', 'with', 'by', 'at']);

/**
 * Format utility name for display: first letter of each word capitalized,
 * except small words like "of", "and", "the" which stay lowercase.
 * Content inside parentheses () is left unchanged (not lowercased).
 * @param {string} name - Raw utility name (e.g. from API or JSON)
 * @returns {string} - Formatted display name
 */
export function formatUtilityDisplayName(name) {
    if (!name || typeof name !== 'string') return name;
    const trimmed = name.trim();
    if (!trimmed) return name;

    const parenMatches = [];
    const withPlaceholders = trimmed.replace(/\([^)]*\)/g, (match) => {
        parenMatches.push(match);
        return `\x00P${parenMatches.length - 1}\x00`;
    });

    const formatted = withPlaceholders
        .split(/\s+/)
        .map((word, index) => {
            if (/^\x00P\d+\x00$/.test(word)) {
                return parenMatches[parseInt(word.replace(/\D/g, ''), 10)];
            }
            const lower = word.toLowerCase();
            const isFirst = index === 0;
            if (!isFirst && SMALL_WORDS.has(lower)) return lower;
            if (word === '&') return word;
            return word.charAt(0).toUpperCase() + word.slice(1).toLowerCase();
        })
        .join(' ');

    return formatted.replace(/\x00P\d+\x00/g, (placeholder) => {
        const i = parseInt(placeholder.replace(/\D/g, ''), 10);
        return parenMatches[i];
    });
}
